<template>
    <section class="section">
        <div class="container">
            <h1 class="title is-4">PDF</h1>
            <p>Nedenstående indstillinger bliver brugt i forbindelse med generering af PDF filer.</p>
            <div class="columns">
                <div class="column is-half">
                    <h2 class="title is-5">Generelt</h2>
                    <setting label="Firma navn" skey="company.name" />
                    <setting label="CVR" skey="company.cvr" />
                    <setting label="Telefon" skey="company.phone" />
                    <setting label="E-mail" skey="company.email" />
                    <setting label="Website" skey="company.website" />
                    <setting label="Tillægstekst (DK)" skey="company.note.dk" />
                    <setting label="Tillægstekst (EN)" skey="company.note.en" />
                </div>
                <div class="column is-half">
                    <h2 class="title is-5">Adresse</h2>
                    <setting label="Vej + vejnummer" skey="company.address" />
                    <setting label="By" skey="company.city" />
                    <setting label="Postnummer" skey="company.zipcode" />
                    <setting label="Land" skey="company.country" />
                </div>
            </div>
            <div class="columns">
                <div class="column is-half">
                    <h2 class="title is-5">Bank (DKK)</h2>
                    <setting label="Bank" skey="company.bank" />
                    <setting label="Reg nr." skey="company.reg" />
                    <setting label="Konto nr." skey="company.account" />
                    <setting label="IBAN nr." skey="company.iban" />
                    <setting label="SWIFT Kode" skey="company.swift" />
                </div>
                <div class="column is-half">
                    <h2 class="title is-5">Bank (EUR)</h2>
                    <setting label="Bank" skey="company.eur.bank" />
                    <setting label="Reg nr." skey="company.eur.reg" />
                    <setting label="Konto nr." skey="company.eur.account" />
                    <setting label="IBAN nr." skey="company.eur.iban" />
                    <setting label="SWIFT Kode" skey="company.eur.swift" />
                </div>
            </div>
            <div class="columns">
                <div class="column is-half">
                    <h2 class="title is-5">Logo</h2>
                    <p>Upload billede 300x62px eller større i PNG-format.</p>
                    <setting-file label="Logo" skey="company.logo" />
                </div>
                <div class="column is-half">
                    <h2 class="title is-5">Salgs- og leveringsbetingelser</h2>
                    <p>Dansk PDF</p>
                    <setting-file label="DKK" skey="company.terms_pdf" />
                    <p>Engelsk PDF</p>
                    <setting-file label="EUR" skey="company.eur.terms_pdf" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Setting from './Setting.vue'
import SettingFile from "./SettingFile";

export default {
    name: "Company",
    components: {
        Setting,
        SettingFile,
    },

    created() {
        this.$store.dispatch('loadSettings')
    },
}
</script>

<style scoped>

</style>
